import { render, staticRenderFns } from "./GaugeSemaforo.vue?vue&type=template&id=22680700"
import script from "./GaugeSemaforo.vue?vue&type=script&lang=js"
export * from "./GaugeSemaforo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports